import React from 'react';
import styles from '../css/primereact/resources/themes/tailwind-light/theme.module.css';

const NoPage = () => {
  return <h1 className={styles["p-component"]} style={{textDecorationLine: 'Underline', textAlign: 'center'}}>404</h1>;
};

export default NoPage;
